export default {
    documentTitle: "DOCUMENT_TITLE",
    documentLastAdded: "DOCUMENT_LAST_ADDED",
    documentCategoriesHeader: "DOCUMENT_CATEGORIES_HEADER",
    documentAdd: "DOCUMENT_ADD",
    documentEditOrShare: "DOCUMENT_EDIT_OR_SHARE",
    documentEdit: "DOCUMENT_EDIT",
    documentShare: "DOCUMENT_SHARE",
    documentSave: "DOCUMENT_SAVE",
    documentDelete: "DOCUMENT_DELETE",
    documentDeleteMessage: "DOCUMENT_DELETE_MESSAGE",
    documentDeleteSelectionMessage: "DOCUMENT_DELETE_SELECTION_MESSAGE",
    documentCreator: "DOCUMENT_CREATOR",
    documentFirstSectionTitle: "DOCUMENT_FIRST_SECTION_TITLE",
    documentSecondSectionTitle: "DOCUMENT_SECOND_SECTION_TITLE",
    documentThirdSectionTitle: "DOCUMENT_THIRD_SECTION_TITLE",
    documentSectionTitle: {
      first: "DOCUMENT_FIRST_SECTION_TITLE2",
      firstBis: "DOCUMENT_FIRST_BIS_SECTION_TITLE2",
      second: "DOCUMENT_SECOND_SECTION_TITLE2",
      third: "DOCUMENT_THIRD_SECTION_TITLE2"
    },
    document_headers: {
        filename: "DOCUMENT_HEADERS_FILENAME",
        addedAt: "DOCUMENT_HEADERS_ADDED_AT",
        addedBy: "DOCUMENT_HEADERS_ADDED_BY",
        ref: "DOCUMENT_HEADER_REF"
    },
    document_form: {
        blocks: "DOCUMENT_FORM_BLOCKS",
        apartments: "DOCUMENT_FORM_APARTMENTS",
        shareWithBlockOwners: "DOCUMENT_FORM_SHARE_BlOCK_OWNERS",
        shareWithBlockTenants: "DOCUMENT_FORM_SHARE_BLOCK_TENANTS",
        shareWithApartmentOwners: "DOCUMENT_FORM_SHARE_APARTMENT_OWNERS",
        shareWithApartmentTenants: "DOCUMENT_FORM_SHARE_APARTMENT_TENANTS",
        shareWithManagers: "DOCUMENT_FORM_SHARE_MANAGERS",
        shareWithEntities: "DOCUMENT_FORM_SHARE_ENETITIES",
        shareDescription: "DOCUMENT_FORM_SHARE_DESCRIPTION",
        shareWithAllBlocks: "DOCUMENT_FORM_SHARE_ALL_BLOCKS"
    },
    block: "DOCUMENT_BLOCK",
    apartment: "DOCUMENT_APARTMENT",
    documentTooBigFile: "DOCUMENT_TOO_BIG_FILE",
    documentUploadFiles: "DOCUMENT_UPLOAD_FILES",
    documentCategory:"DOCUMENT_CATEGORY",
    documentSubCategory:"DOCUMENT_SUBCATEGORY",
}



// WEBPACK FOOTER //
// ./src/locales/document/index.ts